<form [formGroup]="form">
  <!-- START DATE -->
  <div class="date-range-block first">
    <goab-block gap="s" alignment="end">
      <goab-form-item [label]="startLabel" [helpText]="startHelperText">
        <div class="date-time-row">
          <goab-date-picker
            name="startDate"
            [value]="form.controls.startDate.value"
            (onChange)="onDateChange($event, 'startDate')"
          ></goab-date-picker>

          <goab-dropdown
            name="startHour"
            [value]="form.controls.startHour.value"
            (onChange)="onDropdownChange($event, 'startHour')"
            width="100px"
          >
            <goab-dropdown-item
              *ngFor="let opt of hours12Options"
              [value]="opt.value"
              [label]="opt.label"
            ></goab-dropdown-item>
          </goab-dropdown>

          <goab-dropdown
            name="startMinute"
            [value]="form.controls.startMinute.value"
            (onChange)="onDropdownChange($event, 'startMinute')"
            width="100px"
          >
            <goab-dropdown-item
              *ngFor="let opt of minuteOptions"
              [value]="opt.value"
              [label]="opt.label"
            ></goab-dropdown-item>
          </goab-dropdown>

          <goab-dropdown
            name="startMeridiem"
            [value]="form.controls.startMeridiem.value"
            (onChange)="onDropdownChange($event, 'startMeridiem')"
            width="100px"
          >
            <goab-dropdown-item
              *ngFor="let opt of meridiemOptions"
              [value]="opt.value"
              [label]="opt.label"
            ></goab-dropdown-item>
          </goab-dropdown>
        </div>
      </goab-form-item>

      <goab-button
        type="tertiary"
        (onClick)="clearStart()"
        class="clear-button"
        [class]="!startHelperText ? 'noHelperText' : 'helperText'"
        >Clear</goab-button
      >
    </goab-block>
  </div>

  <!-- END DATE -->
  <div class="date-range-block">
    <goab-block gap="s" alignment="end">
      <goab-form-item [label]="endLabel" [helpText]="endHelperText">
        <div class="date-time-row">
          <goab-date-picker
            name="endDate"
            [value]="form.controls.endDate.value"
            (onChange)="onDateChange($event, 'endDate')"
          ></goab-date-picker>

          <goab-dropdown
            name="endHour"
            [value]="form.controls.endHour.value"
            (onChange)="onDropdownChange($event, 'endHour')"
            width="100px"
          >
            <goab-dropdown-item
              *ngFor="let opt of hours12Options"
              [value]="opt.value"
              [label]="opt.label"
            ></goab-dropdown-item>
          </goab-dropdown>

          <goab-dropdown
            name="endMinute"
            [value]="form.controls.endMinute.value"
            (onChange)="onDropdownChange($event, 'endMinute')"
            width="100px"
          >
            <goab-dropdown-item
              *ngFor="let opt of minuteOptions"
              [value]="opt.value"
              [label]="opt.label"
            ></goab-dropdown-item>
          </goab-dropdown>

          <goab-dropdown
            name="endMeridiem"
            [value]="form.controls.endMeridiem.value"
            (onChange)="onDropdownChange($event, 'endMeridiem')"
            width="100px"
          >
            <goab-dropdown-item
              *ngFor="let opt of meridiemOptions"
              [value]="opt.value"
              [label]="opt.label"
            ></goab-dropdown-item>
          </goab-dropdown>
        </div>
      </goab-form-item>

      <goab-button
        type="tertiary"
        (onClick)="clearEnd()"
        class="clear-button"
        [class]="!endHelperText ? 'noHelperText' : 'helperText'"
        >Clear</goab-button
      >
    </goab-block>
  </div>
</form>
